
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/shows/[projectSlug]",
      function () {
        return require("private-next-pages/[locale]/shows/[projectSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/shows/[projectSlug]"])
      });
    }
  